import React from "react";

const AppointmentStatus = ({ status }) => {
  return (
    <div className="mt-6 p-4 bg-blue-50 rounded">

      <h3 className="font-semibold">
        Application Status
      </h3>

      <p>
        Status: {status.status}
      </p>

      {status.appointmentDate && (
        <p>
          Appointment Date: {status.appointmentDate}
        </p>
      )}

    </div>
  );
};

export default AppointmentStatus;